import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { LangChangeEvent, TranslateModule, TranslateService } from '@ngx-translate/core';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { Subscription } from 'rxjs';
import { InfoBoxComponent } from '../../utility/info-box/info-box.component';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { format } from 'date-fns';
import { UserAccountDTO } from '../../../classes/user-account.dto';
import { IDocumentCard } from '../../../interfaces/document-card.interface';
import { AppointmentStepperService } from '../../../services/appointment-stepper.service';
import { HttpService } from '../../../services/http.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-one-radio-info',
  standalone: true,
  imports: [ReactiveFormsModule, NzRadioModule, CommonModule, TranslateModule, NzIconModule, InfoBoxComponent, NzUploadModule],
  templateUrl: './one-radio-info.component.html',
  styleUrl: './one-radio-info.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class OneRadioInfoComponent implements OnInit, OnDestroy {
  @Input() survey?: any;
  @Output() oneRadioInfoEmitter: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
  radioForm?: FormGroup;
  subscriptions: Array<Subscription> = [];
  texts!: any;
  uploadForm?: FormGroup;
  document!: any;
  documentIsUploading: boolean = false;
  progressPercentage: string = '0';
  pathologyItemsSelect: Array<any> = [];
  endDateDocument: Date = new Date();
  startDateDocument: Date = new Date(1950);

  constructor(
    private translateService: TranslateService,
    private fb: FormBuilder,
    private http: HttpService,
    private appointmentsService: AppointmentStepperService,
    private translate: TranslateService,
    private toast: ToastrService
  ) {}

  public ngOnInit(): void {
    this.getForm();
    this.getText();
  }

  private getText(): void {
    this.translateService.onLangChange.subscribe((_: LangChangeEvent): void => {
      this.translateService.get('steps.oneRadioInfo.texts').subscribe((res): Subscription => (this.texts = res));
    });
    this.translateService.get('steps.oneRadioInfo.texts').subscribe((res): Subscription => (this.texts = res));
  }

  emitOneRadioInfoForm(): void {
    if (this.radioForm) {
      this.subscriptions.push(
        this.radioForm.valueChanges.subscribe((_): void => {
          this.oneRadioInfoEmitter.emit(this.radioForm);
        })
      );
    }
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription: Subscription): void => {
      subscription.unsubscribe();
    });
  }
  beforeUpload = (file: any): boolean => {
    this.documentIsUploading = true;
    this.progressPercentage = '30';
    const isPDFOrImage = file.type === 'application/pdf' || file.type.startsWith('image/jpeg') || file.type.startsWith('image/png');
    if (!isPDFOrImage) {
      this.progressPercentage = '50';
      this.documentIsUploading = false;
      alert('Puoi caricare solo file PDF, JPEG o PNG.');
      return false;
    } else {
      this.progressPercentage = '50';
      this.progressPercentage = '80';
      this.documentIsUploading = false;
      this.document = file;
      this.uploadForm?.get('docName')?.setValue(this.document.name);
    }
    this.uploadForm?.get('documentType')?.valueChanges.subscribe((formValues) => {
      if (this.document) {
        this.sendData();
      }
    });
    return true;
  };

  public deleteDoc(): void {
    this.document = null;
    this.documentIsUploading = false;
  }

  private getForm() {
    this.uploadForm = this.fb.group({ docName: [null], documentType: [''] });
    if (this.survey && this.survey.length > 0) {
      this.radioForm = this.fb.group({});
      this.survey.forEach((res: any, index: any) => {
        if (res) {
          this.radioForm?.addControl(index, new FormControl(null, Validators.required));
        }
      });
      this.emitOneRadioInfoForm();
    }
  }

  public sendData(): void {
    const formData = new FormData();
    formData.append('files[0]', this.document);
    formData.append('docname', this.uploadForm?.get('docName')?.value);
    formData.append('doctype', this.uploadForm?.get('documentType')?.value);
    formData.append('docdate', format(new Date(), 'yyyy-MM-dd'));
    formData.append('docpathology', '');
    formData.append('docnote', '');
    formData.append('doccaremanagerrequest', 'false');
    formData.append('dossiercode', '');

    this.http.uploadDocuments(formData).subscribe((res) => {
      const documentLoaded: IDocumentCard = {
        id: res.doc.id,
        title: res.doc.documentName,
        icon: res.doc.type.startsWith('Referto') ? 'file-icon.svg' : 'file-blue.svg',
        date: format(new Date(res.doc.documentDate), 'dd MMM yyyy'),
        type: res.doc.type,
        additional_text: 'reportsPage.document_type',
      };
      this.appointmentsService.setDocuments(documentLoaded);
      this.toast.success(this.translate.instant('loadDocumentModal.success'));
    });
  }
}
